<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div>
  <div *ngIf="isLoadingAnnouncements || carouselContents.length === 0" class="my-2 mx-10 d-flex justify-content-center align-items-center">
    <img src="assets/images/bangunan.jpg" class="carousel-size" alt="default-banner">
  </div>
  <div *ngIf="!isLoadingAnnouncements && carouselContents.length > 0" id="carouselDashboard" class="carousel carousel-dark slide carousel-fade my-2 mx-10 d-flex justify-content-center align-items-center">
    <div class="carousel-inner">
      <div *ngFor="let item of carouselContents; let i = index" class="carousel-item" [class.active]="i === 0">
        <div class="announcement-slide">
          <div class="announcement-card">
            <div class="announcement-header">
              <div class="announcement-title">
                <i class="bi bi-megaphone-fill me-2"></i>
                {{ item.contentTitle }}
              </div>
              <div class="announcement-date">
                {{ item.contentDate }}
              </div>
            </div>
            <div class="announcement-body">
              <div class="announcement-content">
                <div class="announcement-text" [innerHTML]="item.contentText"></div>
              </div>
              <div class="text-center attachment-button" *ngIf="hasAttachment(item)">
                <button type="button" class="btn announcement-btn px-4 shadow-sm" data-bs-toggle="modal" data-bs-target="#attachmentModal"
                (click)="setSelectedAttachment(item)">
                  <i class="bi bi-file-earmark-text-fill attachment-icon"></i>
                  Lihat Lampiran
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button *ngIf="carouselContents.length > 1" class="carousel-control-prev" type="button" data-bs-target="#carouselDashboard" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button *ngIf="carouselContents.length > 1" class="carousel-control-next" type="button" data-bs-target="#carouselDashboard" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
  <div class="row w-100 justify-content-center pt-5 pb-5">
    <div class="col-3">
      <div class="card shadow card-size border-0">
        <div class="card-image-parent">
          <img src="./assets/images/card-1.png" class="card-img-top card-image1" alt="..." />
          <img src="./assets/images/card-mask2.png" class="card-img-top card-image2" alt="..." />
          <img src="./assets/images/card-mask.png" class="card-img-top card-image3" alt="..." />
          <span class="position-absolute top-50 start-0 translate-middle-y text-white ps-4">
            <img src="./assets/icons/envelope-file-yellow.svg" alt="..." />
            <p class="header-text pt-4 fw-bold">Pembayar Cukai</p>
          </span>
        </div>
        <div class="card-body ps-4">
          <a routerLink="/penerimaan-pelantikan-permohonan-online" class="text-decoration-none text-black link arrow">Penerimaan Pelantikan Ejen Cukai</a>
          <hr />
          <a routerLink="/e-borang" class="text-decoration-none text-black link arrow">e-Borang</a>
          <hr />
          <a routerLink="/status-e-borang" class="text-decoration-none text-black link arrow">Status e-Borang</a>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="card shadow border-0">
        <div class="card-image-parent">
          <img src="./assets/images/card-2.png" class="card-img-top card-image1" alt="..." />
          <img src="./assets/images/card-mask2.png" class="card-img-top card-image2" alt="..." />
          <img src="./assets/images/card-mask.png" class="card-img-top card-image3" alt="..." />
          <span class="position-absolute top-50 start-0 translate-middle-y text-white ps-4">
            <img src="./assets/icons/share-circle-yellow.svg" alt="..." />
            <p class="header-text pt-4 fw-bold">Integrasi</p>
          </span>
        </div>
        <div class="card-body ps-4">
          <a href="#" data-bs-toggle="modal" data-bs-target="#dtsModal" class="text-decoration-none text-black link arrow">e-Dts</a>
          <hr />
          <!--<a class="text-decoration-none text-black link arrow" data-bs-toggle="modal" data-bs-target="#penampanModal">MITRS</a>-->
          <a routerLink="/mitrs" class="text-decoration-none text-black link arrow">MITRS</a>
          <hr />
          <a *ngIf="showEWHT" routerLink="/e-wht" class="text-decoration-none text-black link arrow">e-WHT/ANSURAN/107D</a>
          <hr *ngIf="showEWHT"/>
          <a routerLink="/e-ckht" class="text-decoration-none text-black link arrow">e-CKHT</a>
          <hr />
          <a routerLink="/e-ckm-cp22" class="text-decoration-none text-black link arrow">{{ integrasiCkmTitle }}</a>
          <hr />
          <a routerLink="/e-spc" class="text-decoration-none text-black link arrow">e-SPC</a>
          <hr />
          <a *ngIf="showEOT" routerLink="/e-eot" class="text-decoration-none text-black link arrow">e-Lanjutan Masa</a>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="card shadow card-size border-0">
        <div class="card-image-parent">
          <img src="./assets/images/card-3.png" class="card-img-top card-image1" alt="..." />
          <img src="./assets/images/card-mask2.png" class="card-img-top card-image2" alt="..." />
          <img src="./assets/images/card-mask.png" class="card-img-top card-image3" alt="..." />
          <span class="position-absolute top-50 start-0 translate-middle-y text-white ps-4">
            <img src="./assets/icons/folder-gear-circle-yellow.svg" alt="..." />
            <p class="header-text pt-4 fw-bold">Penyenggaraan</p>
          </span>
        </div>
        <div class="card-body ps-4">
          <a routerLink="/daftar-kemaskini" class="text-decoration-none text-black link arrow">Daftar / Kemaskini Pengguna</a>
          <hr />
          <a routerLink="/carian-hubungan" class="text-decoration-none text-black link arrow">Carian Hubungan</a>
          <hr />
          <a routerLink="/agihan-hubungan" class="text-decoration-none text-black link arrow">Agihan Hubungan</a>
          <hr />
          <a routerLink="/log-audit" class="text-decoration-none text-black link arrow">Log Audit</a>
          <hr />
          <a routerLink="/agih-e-borang-ejen-cukai" class="text-decoration-none text-black link arrow">Agih e-Borang (Ejen Cukai)</a>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Ad Modal -->
<div class="modal fade " id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl ">
    <div class="modal-content border-0" style="background-color: transparent !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-center align-items-center pb-5">
          <img class="rounded-3" src="./assets/images/efiling-ad.jpg" width="901" height="177" alt="..." />
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <button type="button" class="btn" style="background-color: #082497;">
            <span class="text-white">
              INFO
              LANJUT:
            </span><span class="fw-bold" style="color: #FFFF00;">{{ MyTaxAddress }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- BAS/DTS Modal -->
<div class="modal fade" id="dtsModal" tabindex="-1" aria-labelledby="dtsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content" style="background-color: #EBEBEB !important;">
      <div class="modal-body">
        <div class="row">
          <div class="col d-flex flex-column justify-content-start align-items-start">
            <p class="fw-bold">Integrasi</p>
            <p>e-Dts :</p>
          </div>
          <div class="col d-flex justify-content-end align-items-start">
            <button type="button" class="btn bi bi-x-square-fill" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>
        <hr style="background-color: #000 !important;" />

        <div class="container px-5 g-0">
          <div class="row ">
            <div class="col-3">
              <div routerLink="/profil-firma" data-bs-dismiss="modal" class="card inner-card shadow modal-card-size d-flex justify-content-center align-items-center rounded-4">
                <img src="./assets/icons/user-many.svg" class="card-img-top modal-icon-size mt-3" alt="...">
                <div class="card-body">
                  <h5 class="card-title">Profil Firma</h5>
                </div>
              </div>
            </div>

            <!--<div class="col">
              <div class="card inner-card shadow modal-card-size d-flex justify-content-center align-items-center rounded-4">
                <img src="./assets/icons/arrow-top-circle-yellow.svg" class="card-img-top modal-icon-size mt-3" alt="...">
                <div class="card-body">
                  <h5 class="card-title">Muat Naik XML (e-BaS / e-Dts)</h5>
                </div>
              </div>
            </div>-->
            <!--<div class="col">
              <div class="card shadow modal-card-size d-flex justify-content-center align-items-center rounded-4">
                <img src="./assets/icons/arrow-top-circle-yellow.svg" class="card-img-top modal-icon-size mt-3" alt="...">
                <div class="card-body">
                  <h5 class="card-title fs-8">Muat Naik XML (e-BaS / e-Dts) Bukan Lantikan</h5>
                </div>
              </div>
            </div>-->

            <div class="col-3">
              <div routerLink="/cetak-draf" data-bs-dismiss="modal" class="card inner-card shadow modal-card-size d-flex justify-content-center align-items-center rounded-4" routerLink="/cetak-draf" data-bs-dismiss="modal">
                <img src="./assets/icons/printer.svg" class="card-img-top modal-icon-size mt-3" alt="...">
                <div class="card-body">
                  <h5 class="card-title">Cetak Draf</h5>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div routerLink="/penghantaran-e-borang" data-bs-dismiss="modal" class="card inner-card shadow modal-card-size d-flex justify-content-center align-items-center rounded-4">
                <img src="./assets/icons/paper-arrow-right-yellow-circle.svg" class="card-img-top modal-icon-size mt-3" alt="...">
                <div class="card-body">
                  <h5 class="card-title">Penghantaran e-Borang</h5>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="row pt-3">
            <div class="col">
              <div routerLink="/penghantaran-e-borang" data-bs-dismiss="modal" class="card inner-card shadow modal-card-size d-flex justify-content-center align-items-center rounded-4">
                <img src="./assets/icons/paper-arrow-right-yellow-circle.svg" class="card-img-top modal-icon-size mt-3" alt="...">
                <div class="card-body">
                  <h5 class="card-title">Penghantaran e-Borang</h5>
                </div>
              </div>
            </div>
          </div>-->
        </div>

      </div>
    </div>
  </div>
</div>

<!--PENAMPAN Modal-->
<div class="modal fade" id="penampanModal" tabindex="-1" aria-labelledby="penampanModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" style="background-color: rgba(223, 224, 224, 0.9);border-radius: 1.7rem !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-center align-items-center">
          <img src="../../../../assets/icons/restricted.svg" height="90" width="90" alt="..." />
        </div>
        <h3 class="fw-bold text-center">PEMAKLUMAN NOTIS PEMBERITAHUAN</h3>
        <p class="text-center">
          Pembayar cukai yang dihormati
        </p>
        <!--<p class="text-center">
          Dimaklumkan capaian ke menu MITRS sedang mengalami gangguan pada<span class="fw-bold"> Jumaat 19 September 2025 pukul 10.00 malam sehingga 11.00 malam.</span>
        </p>-->
        <p class="text-center">
          Dimaklumkan bahawa perkhidmatan e-MITRS di TAeF sedang mengalami gangguan. Tindakan pembaikan sedang dilaksanakan.
        </p>
        <p class="text-center">
          Mohon maaf atas kesulitan
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Attachment Modal -->
<div class="modal fade attachmentModal" id="attachmentModal" tabindex="-1" aria-labelledby="attachmentModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="attachmentModalLabel">
          {{ selectedAttachment?.contentTitle || 'Attachment' }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        (click)="clearSelectedAttachment()">
        </button>
      </div>
      <div class="modal-body p-0">
        <div *ngIf="isAttachmentLoading" class="text-center py-5">
          <div class="spinner-border text-warning" role="status"></div>
        </div>
        <div *ngIf="!isAttachmentLoading && attachmentLoadMessage" class="text-center py-5 text-danger">
          {{ attachmentLoadMessage }}
        </div>
        <!-- Keep preview rendered (hidden while loading) so load event can fire -->
        <div [class.d-none]="isAttachmentLoading || !!attachmentLoadMessage">
          <!-- PDF / unknown -->
          <div *ngIf="selectedAttachmentMimeType?.includes('pdf') || !selectedAttachmentMimeType" class="pdf-container">
            <iframe *ngIf="selectedAttachmentUrl" [src]="selectedAttachmentUrl" class="pdf-viewer" title="Attachment Preview"
            (load)="onAttachmentPreviewLoaded()">
            </iframe>
          </div>
          <!-- Image -->
          <div *ngIf="selectedAttachmentMimeType?.startsWith('image/')" class="text-center p-4">
            <img *ngIf="selectedAttachmentDirectUrl"
            [src]="selectedAttachmentDirectUrl" class="img-fluid attachment-preview-image" alt="Attachment"
            (load)="onAttachmentPreviewLoaded()"
            (error)="onAttachmentPreviewError()" />
          </div>
          <!-- Other file -->
          <div *ngIf="selectedAttachment && selectedAttachmentMimeType && 
          !selectedAttachmentMimeType.includes('pdf') && 
          !selectedAttachmentMimeType.startsWith('image/')"
          class="text-center py-5">
            <i class="bi bi-file-earmark-text-fill" style="font-size: 60px;"></i>
            <p class="mt-3">Attachment preview is not available.</p>
            <button type="button" class="btn btn-primary" 
            (click)="openAttachment()">
              <i class="bi bi-box-arrow-up-right me-2"></i>
              Open Attachment
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" 
        (click)="clearSelectedAttachment()">
        Tutup
        </button>
      </div>
    </div>
  </div>
</div>

